<template>
  <div class="row align-items-center justify-content-center">
    <div class="col-12 col-md-8 col-lg-6 col-xl-4 px-lg-6 my-5">
      <h1>Set New Password</h1>

      <p>Please enter a new password for your account.</p>

      <div class="alert alert-danger" v-if="error" v-html="error"/>

      <form @submit.prevent>
        <div class="form-group">
          <label>New Password</label>
          <input
            type="password"
            class="form-control"
            name="password"
            v-validate="'required|password'"
            v-model="password"
          >

          <help-block field="password"/>
        </div>
        <!-- /.form-group -->

        <div class="form-group">
          <label>Repeat New Password</label>
          <input
            type="password"
            class="form-control"
            name="password_confirmation"
            v-validate="{ required: true, is: password, password: true }"
            v-model="passwordConfirmation"
            data-vv-as="password confirmation"
          >

          <help-block field="password_confirmation"/>
        </div>
        <!-- /.form-group -->

        <ladda-button
          type="submit"
          :validate="true"
          :click="updatePassword"
          :arguments="[payload]"
          :done="success"
          :failed="failed"
          class="btn btn-block btn-primary mb-3"
        >Set Password</ladda-button>
      </form>
    </div>
  </div>
  <!-- /.row -->
</template>

<script>
import { authMethods } from 'vx/helpers'

export default {
  computed: {
    payload () {
      return {
        password: this.password,
        password_confirmation: this.passwordConfirmation
      }
    }
  },

  data () {
    return {
      error: null,
      password: null,
      passwordConfirmation: null
    }
  },

  created () {
    if (this.$user.one_time_password !== true) {
      this.$router.replace({ name: 'login' })
    }
  },

  methods: {
    ...authMethods,

    success () {
      this.$router.push({ name: 'dashboard' })

      this.$noty.success('Your password has been set.')
    },

    failed (error) {
      if (error.response && error.response.status === 422 && error.response.data.errors.generic) {
        this.error = error.response.data.errors.generic.pop()
      }

      if (error.response && error.response.status === 422) {
        this.error = error.response.data.errors.password.pop()
      }
    }
  }
}
</script>
